<template>
  <div class="recharge-proxy-container">
    <!-- Search and Action Section -->
    <div class="search-action">
      <el-input
          v-model="searchForm.account"
          placeholder="搜索代充账号"
          clearable
          @clear="handleSearch"
          @input="handleSearch"
      >
      </el-input>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="success" size="small" @click="showAddDialog">新增代充</el-button>
      </div>
      <div class="status-counts">
        <div>首充完成: {{ statusCounts[0] }}</div>
        <div>复充完成: {{ statusCounts[1] }}</div>
        <div>退款成功: {{ statusCounts[2] }}</div>
      </div>

    </div>

    <!-- Table Section -->
    <el-table :data="rechargeProxies" border style="width: 100%">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="account" label="账号" width="120"></el-table-column>
      <el-table-column label="密码" width="180">
        <template slot-scope="scope">
          <span>{{ hidePassword(scope.row.password) }}</span>
          <el-button
              size="mini"
              icon="el-icon-document-copy"
              @click="copyPassword(scope.row.password)"
          >复制</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="firstRechargeDate" label="首充日期" width="160">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.firstRechargeDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="rechargeRepeatDate" label="复充日期" width="160">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.rechargeRepeatDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="refundDate" label="退款日期" width="160">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.refundDate) }}
        </template>
      </el-table-column>
      <el-table-column label="距退款" width="60">
        <template slot-scope="scope">
          {{ calculateRemainingDays(scope.row.refundDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="isMirrorSite" label="镜像站" width="60">
        <template slot-scope="scope">
          {{ scope.row.isMirrorSite === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column prop="processStatus" label="处理状态" width="70">
        <template slot-scope="scope">
          <span :class="getProcessStatusClass(scope.row.processStatus)">
            {{ ['首充完成', '复充完成', '退款成功'][scope.row.processStatus] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="handleRecharge(scope.row)" v-if="scope.row.processStatus === 0">复充</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Pagination Section -->
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>

    <!-- Add/Edit Dialog -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" @close="resetForm">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="账号" prop="account" :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]">
          <el-input v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="首充日期" prop="firstRechargeDate" :rules="[{ required: true, message: '请选择首充日期', trigger: 'change' }]">
          <el-date-picker
              v-model="form.firstRechargeDate"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="复充日期" prop="rechargeRepeatDate">
          <el-date-picker
              v-model="form.rechargeRepeatDate"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="退款日期" prop="refundDate">
          <el-date-picker
              v-model="form.refundDate"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否镜像站" prop="isMirrorSite">
          <el-radio-group v-model="form.isMirrorSite" disabled>
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="处理状态" prop="processStatus">
          <el-select v-model="form.processStatus">
            <el-option :value="0" label="首充完成"></el-option>
            <el-option :value="1" label="复充完成"></el-option>
            <el-option :value="2" label="退款成功"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      statusCounts: [0, 0, 0],
      searchForm: {
        account: '',
        isMirrorSite: 0  // 默认搜索非镜像站
      },
      rechargeProxies: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增代充',
      form: {
        id: null,
        account: '',
        password: '',
        firstRechargeDate: '',
        rechargeRepeatDate: '',
        refundDate: '',
        isMirrorSite: 0,
        processStatus: 0
      }
    };
  },
  created() {
    this.setupAxiosInterceptors();
  },
  methods: {
    setupAxiosInterceptors() {
      axios.interceptors.request.use(
          config => {
            const token = this.$cookies.get('token');
            if (token) {
              config.headers['token'] = token;
            }
            return config;
          },
          error => {
            return Promise.reject(error);
          }
      );

      axios.interceptors.response.use(
          response => response,
          error => {
            if (error.response && error.response.status === 401) {
              this.$message.error('认证失败，请重新登录');
              this.$router.push('/login');
            }
            return Promise.reject(error);
          }
      );
    },
    async fetchRechargeProxies() {
      try {
        const response = await axios.post('/api/admin/recharge/page', {
          current: this.currentPage,
          size: this.pageSize,
          account: this.searchForm.account,
          isMirrorSite: 0  // 固定为非镜像站
        });
        if (response.data.code === 200) {
          this.rechargeProxies = response.data.data;
          this.total = response.data.total;
          this.currentPage = response.data.current;
          this.pageSize = response.data.size;
          this.calculateStatusCounts();
        } else {
          this.$message.error(response.data.msg || '获取代充记录失败');
        }
      } catch (error) {
        console.error('Error fetching recharge proxies:', error);
        this.$message.error('获取代充记录失败');
      }
    },

    calculateStatusCounts() {
      this.statusCounts = [0, 0, 0];
      this.rechargeProxies.forEach(proxy => {
        if (proxy.processStatus >= 0 && proxy.processStatus <= 2) {
          this.statusCounts[proxy.processStatus]++;
        }
      });
    },

    handleSearch() {
      this.currentPage = 1;
      this.fetchRechargeProxies();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchRechargeProxies();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchRechargeProxies();
    },
    showAddDialog() {
      this.dialogTitle = '新增代充';
      this.dialogVisible = true;
      this.form = {
        id: null,
        account: '',
        password: '',
        firstRechargeDate: '',
        rechargeRepeatDate: '',
        refundDate: '',
        isMirrorSite: 0,  // 默认为非镜像站
        processStatus: 0
      };
    },

    handleEdit(row) {
      this.dialogTitle = '编辑代充';
      this.dialogVisible = true;
      this.form = { ...row };
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这条记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const response = await axios.post('/api/admin/removeRecharge', null, {
          params: { id: row.id }
        });
        if (response.data.code === 200) {
          this.$message.success('删除成功');
          this.fetchRechargeProxies();
        } else {
          this.$message.error(response.data.msg || '删除失败');
        }
      } catch (error) {
        console.error('Error deleting recharge proxy:', error);
        this.$message.error('删除失败');
      }
    },
    async handleRecharge(row) {
      try {
        const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const timestamp = moment().valueOf();
        const response = await axios.post('/api/admin/updateRecharge', {
          id: row.id,
          isRecharge: 'true',
          rechargeRepeatDate: currentTime,
          timestamp: timestamp
        });
        if (response.data.code === 200) {
          this.$message.success('复充成功');
          this.fetchRechargeProxies();
        } else {
          this.$message.error(response.data.msg || '复充失败');
        }
      } catch (error) {
        console.error('Error recharging:', error);
        this.$message.error('复充失败');
      }
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    async submitForm() {
      try {
        await this.$refs.form.validate();
        const response = await axios.post('/api/admin/saveOrUpdateRecharge', this.form);
        if (response.data.code === 200) {
          this.$message.success('操作成功');
          this.dialogVisible = false;
          this.fetchRechargeProxies();
        } else {
          this.$message.error(response.data.msg || '操作失败');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        this.$message.error('提交失败');
      }
    },
    formatDateTime(dateTime) {
      return dateTime ? moment(dateTime).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    calculateRemainingDays(refundDate) {
      if (!refundDate) return '未设置';
      const now = moment();
      const refund = moment(refundDate);
      const diff = refund.diff(now, 'days');
      return diff < 0 ? '已过期' : `${diff}天`;
    },
    getProcessStatusClass(status) {
      switch (status) {
        case 0:
          return 'status-green';
        case 1:
          return 'status-blue';
        case 2:
          return 'status-white';
        default:
          return '';
      }
    },
    hidePassword(password) {
      return password ? '*'.repeat(password.length) : '';
    },
    copyPassword(password) {
      navigator.clipboard.writeText(password).then(() => {
        this.$message.success('密码已复制到剪贴板');
      }).catch(err => {
        console.error('Failed to copy password: ', err);
        this.$message.error('复制密码失败');
      });
    }
  },
  mounted() {
    this.fetchRechargeProxies();
  }
};
</script>


<style scoped>

.search-action {
  display: flex;
  width: 360px;
}
.status-counts {
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
  height: 100%;             /* 确保容器有足够的高度 */
}

.status-counts div {
  width: 120px;
  font-size: 14px;
}

.status-green { color: #67C23A; }
.status-blue { color: #409EFF; }
.status-white { color: #909399; }
.status-green {
  color: #67C23A;
  font-weight: bold;
}
.status-blue {
  color: #409EFF;
  font-weight: bold;
}
.status-white {
  color: #909399;
  font-weight: bold;
}
.el-table {
  margin-bottom: 20px;
}
.el-pagination {
  text-align: right;
  margin-top: 20px;
}
.el-button + .el-button {
  margin-left: 10px;
}
.el-table .cell {
  white-space: nowrap;
}
.el-table__expanded-cell {
  padding: 20px 50px;
}
.el-form-item {
  margin-bottom: 22px;
}
.el-dialog__body {
  padding: 30px 20px;
}
.el-dialog__footer {
  padding: 10px 20px 20px;
}
.el-input-number {
  width: 100%;
}
.el-date-editor.el-input {
  width: 100%;
}
</style>